/**
 * @generated SignedSource<<cc5b42262fd9da3bcebce592cc6b42da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespBreadcrumbs_item$data = {
  readonly breadcrumbs: ReadonlyArray<{
    readonly isLinkable: boolean | null;
    readonly path: string | null;
    readonly text: string | null;
  }> | null;
  readonly " $fragmentType": "PdpRespBreadcrumbs_item";
};
export type PdpRespBreadcrumbs_item$key = {
  readonly " $data"?: PdpRespBreadcrumbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespBreadcrumbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespBreadcrumbs_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "breadcrumbs",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "path",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLinkable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "16d087bc64d1129aae9ecf5514c0705d";

export default node;
